var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "#FEAAFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99999 5.08333C3.99999 4.85321 4.18654 4.66667 4.41666 4.66667H13.5833C13.8134 4.66667 14 4.85321 14 5.08333V5.91667C14 6.14679 13.8134 6.33333 13.5833 6.33333H4.41666C4.18654 6.33333 3.99999 6.14679 3.99999 5.91667V5.08333Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41666 8C4.18654 8 3.99999 8.18655 3.99999 8.41667V9.25C3.99999 9.48012 4.18654 9.66667 4.41666 9.66667H13.5833C13.8134 9.66667 14 9.48012 14 9.25V8.41667C14 8.18655 13.8134 8 13.5833 8H4.41666Z",
    fill: "#292929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666656 3C0.666656 1.61929 1.78594 0.5 3.16666 0.5H14.8333C16.214 0.5 17.3333 1.61929 17.3333 3V14.7762C17.3333 16.1074 15.8497 16.9014 14.7422 16.163L11.4576 13.9733C11.3207 13.882 11.1599 13.8333 10.9954 13.8333H3.16666C1.78594 13.8333 0.666656 12.714 0.666656 11.3333V3ZM3.16666 2.16667C2.70642 2.16667 2.33332 2.53976 2.33332 3V11.3333C2.33332 11.7936 2.70642 12.1667 3.16666 12.1667H10.9954C11.4889 12.1667 11.9714 12.3128 12.3821 12.5865L15.6667 14.7762V3C15.6667 2.53976 15.2936 2.16667 14.8333 2.16667H3.16666Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotMsg);
export default __webpack_public_path__ + "static/media/chatbotMsg.1a096a8f1d25f06cd9be0805a84a3191.svg";
export { ForwardRef as ReactComponent };